import React from 'react';
import ReactDOMServer from 'react-dom/server';

import {getLanguageFromClass, CodeBlock} from '../components/SyntaxHighlighter';

/**
 *
 * @param {*} htmlContent raw html content e.g. from blog
 * @returns transformed html content with platform specific components
 *
 * Currently only used to use <CodeBlock>
 */
const transformHTML = (htmlContent) => {
  const regex = /<pre><code class="(.*?)">(.*?)<\/code><\/pre>/gs;

  const transformedContent = htmlContent.replace(regex, (match, className, code) => {
    const cleanedChildren = code.trim();

    const language = getLanguageFromClass(className);

    const codeBlockString = ReactDOMServer.renderToStaticMarkup(
      <CodeBlock language={language.syntax} label={language.label}>
        {cleanedChildren}
      </CodeBlock>,
    );

    return codeBlockString;
  });

  return transformedContent;
};

export default transformHTML;
